import React from 'react';
import { CheckIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_SUMMARY } from './salesData';

/**
 * PRIMERA revelación del precio de toda la carta. El CTA del hero
 * (#oferta) hace smooth-scroll exactamente hasta acá.
 *
 * La caja es deliberadamente corta: el visitante ya recorrió los 8 kits y los
 * 5 bonos más arriba, así que del precio al CTA hay la menor distancia posible.
 */
export function OfferSection() {
  return <section id="oferta" className="scroll-mt-24 bg-charcoal py-14 sm:py-24" aria-labelledby="offer-title" data-id="element-177" data-mp="rdwqznkuz37r">
      <div className="mx-auto w-full max-w-2xl px-4 sm:px-8" data-id="element-178" data-mp="wd9du8bqcaac">
        <div className="text-center" data-id="element-179" data-mp="2t59i99twlclc">
          <SectionTag tone="dark" className="justify-center" data-id="element-180" data-mp="2t6b6kfzxjvl0">
            La inversión
          </SectionTag>
          <h2 id="offer-title" className="mt-4 font-display text-[1.7rem] uppercase leading-[1.06] text-ivory sm:text-[2.6rem]" data-id="element-181" data-mp="2y55nfcec7a2h">
            Todo el sistema. Una sola inversión.
          </h2>
        </div>

        {/* PLACEHOLDER COMERCIAL: acá va cualquier elemento promocional real
            (precio de lista, descuento verificable, fecha límite) cuando exista. */}

        <div className="mt-7 rounded-3xl border border-warm bg-ivory p-5 shadow-[0_40px_80px_-45px_rgba(0,0,0,0.6)] sm:mt-10 sm:p-8" data-id="element-182" data-mp="oxeydfeyrke2">
          <div className="text-center" data-id="element-183" data-mp="1lk0asjd1n5xn">
            <p className="font-display text-[1.05rem] uppercase leading-tight text-charcoal sm:text-[1.3rem]" data-id="element-184" data-mp="1gn1js9ooff3o">
              Sistema IA para Nutricionistas
            </p>
            <div className="mt-3.5 flex flex-wrap items-center justify-center gap-2" data-id="element-185" data-mp="17mv9sxs6sx99">
              <span className="rounded-full bg-charcoal px-3.5 py-1.5 font-sans text-[0.62rem] font-bold uppercase tracking-[0.1em] text-ivory sm:text-[0.7rem]" data-id="element-186" data-mp="17oy0lk15yuf1">
                8 kits profesionales
              </span>
              <span className="font-sans text-sm font-bold text-gold-deep" aria-hidden data-id="element-187" data-mp="3tu9abacuhhjc">
                +
              </span>
              <span className="rounded-full bg-gold px-3.5 py-1.5 font-sans text-[0.62rem] font-bold uppercase tracking-[0.1em] text-charcoal sm:text-[0.7rem]" data-id="element-188" data-mp="2mna5rpc3x78">
                5 bonos de implementación
              </span>
            </div>
          </div>

          <div className="mt-6 border-y border-warm py-6" data-id="element-189" data-mp="3b3i4gis2g99p">
            <PriceBlock size="lg" data-id="element-190" data-mp="3b1x9wt5r4qbu" />
          </div>

          <p className="mt-5 font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-191" data-mp="3ftyj267mi0xn">
            Incluye
          </p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-x-6" data-id="element-192" data-mp="316wwbokr2i1n">
            {OFFER_SUMMARY.map(item => <li key={item} className="flex items-center gap-2.5" data-id="element-193" data-mp="364oqyqcs4i9j">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-gold-pale" aria-hidden data-id="element-194" data-mp="2s5p2bip9o3dd">
                  <CheckIcon className="h-2.5 w-2.5 text-gold-deep" data-id="element-195" data-mp="2dhf6pmt1xz70" />
                </span>
                <span className="font-sans text-[0.85rem] font-medium leading-snug text-charcoal/80" data-id="element-196" data-mp="28jdo12zjg1w2">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-7" data-id="element-197" data-mp="2iha0by47p2vr">
            <CTAButton label="Quiero el Sistema IA para Nutricionistas" size="lg" className="w-full" data-id="element-198" data-mp="2ig8lrjnzly9a" />

            <div className="mt-4 flex flex-col items-center gap-2.5" data-id="element-199" data-mp="2rhzp4hv21szz">
              <p className="rounded-full bg-bone px-4 py-2 font-sans text-[0.66rem] font-bold uppercase tracking-[0.1em] text-charcoal/70" data-id="element-200" data-mp="2rflv8cc42mu0">
                Pagá con Mercado Pago
              </p>
              <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-201" data-mp="319ma35x736fx">
                <li className="flex items-center gap-1.5 font-sans text-[0.74rem] text-charcoal/60" data-id="element-202" data-mp="3f7kb79mi96dh">
                  <ZapIcon className="h-3.5 w-3.5 text-gold-deep" aria-hidden data-id="element-203" data-mp="3aa0w67hzgpkh" /> Acceso inmediato
                </li>
                <li className="flex items-center gap-1.5 font-sans text-[0.74rem] text-charcoal/60" data-id="element-204" data-mp="18h7h79jwyfip">
                  <ShieldCheckIcon className="h-3.5 w-3.5 text-gold-deep" aria-hidden data-id="element-205" data-mp="1dfs8ukl3nqvj" /> Garantía 7
                  días
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center font-sans text-[0.76rem] leading-relaxed text-ivory/45" data-id="element-206" data-mp="pk60wskwsszg">
          El Sistema IA para Nutricionistas es una herramienta de asistencia y productividad
          profesional. No reemplaza el criterio, el diagnóstico ni la indicación del nutricionista.
        </p>
      </div>
    </section>;
}